import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { SHOP_LIST_PATH } from '../../../constants/constants'
import ProLineSideNavMenuItems from '../../molecules/Shop/ProLineSideNavMenuItems'

interface IProLineOffCanvasShopProductsMobileProps {
  handleClose: (() => void | null) | undefined
}

const ProLineOffCanvasShopProductsMobile: React.FC<
  IProLineOffCanvasShopProductsMobileProps
> = ({ handleClose }) => {
  const navigate = useNavigate()

  return (
    <div className="p-3">
      <Button
        variant="danger"
        onClick={() => {
          navigate(SHOP_LIST_PATH)
          handleClose?.()
        }}
        className="mb-3"
      >
        Shop All Products
      </Button>

      <ProLineSideNavMenuItems handleClick={handleClose} />
    </div>
  )
}

export default ProLineOffCanvasShopProductsMobile
